export default "__VITE_ASSET__Bi_A8_av__"